// @flow
import React, { Fragment } from 'react';
import { FileText } from '@finect/tabular-icons/fileText';
import { Eye } from '@finect/tabular-icons/eye';
import { ServiceHead } from '../ServiceHead';
import { ServiceForm } from '../ServiceForm';
import { Link } from '../ServiceHead/partials';

import { AdvisersLeadsDetail, ModalRefuse } from './components';
import { ServiceInner, ServiceDetail, ServiceDetailItem, MenuActionsMobile } from './partials';

type Props = {
  index: number,
  service: Object,
  profileSubscriptions: Array<string>,
  onProfileFollow: Function,
  onRefuse: Function
};
type State = {
  collapse: boolean,
  view: string,
  organization: Object,
  serviceId: string
};

const serviceTitles = {
  'advisers-leads': 'Asesoramiento Financiero',
  taxdown: 'Asesoramiento Fiscal'
};

export class Service extends React.Component<Props, State> {
  state = {
    collapse: true,
    view: '',
    organization: {
      icon: '',
      displayName: '',
      id: ''
    },
    serviceId: ''
  };

  toggleCollapse = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  handleView = (view: string) => {
    if (view.includes('feedback')) {
      const serviceId = view.split('-')[1];
      window.location.href = `/tus-finanzas/asesores/valoracion/${serviceId}`;
    } else {
      this.setState({ view });
      this.setState({ collapse: false });
    }
  };

  handleTransaction = (organization: Object, serviceId: string) => {
    this.setState({ organization, serviceId });
  };

  handleCloseModal = () => {
    this.setState({ organization: null, serviceId: '' });
  };

  handleRefuse = () => {
    this.setState({ collapse: !this.state.collapse });
    this.props.onRefuse(this.state.organization.id, this.state.serviceId);
    this.setState({ organization: null, serviceId: '' });
  };

  componentDidMount() {
    const index = this.props.index;
    if (index === 0) {
      this.toggleCollapse();
    }
  }

  render() {
    const { service } = this.props;
    const appId = service.session.application;
    const title = serviceTitles[appId];
    return (
      <ServiceInner>
        {this.state.organization ? (
          <ModalRefuse
            organization={this.state.organization}
            serviceId={this.state.serviceId}
            handleCloseModal={this.handleCloseModal}
            handleRefuse={this.handleRefuse}
          />
        ) : null}

        <Fragment>
          <ServiceHead
            title={title}
            onToggle={this.toggleCollapse}
            onChangeView={this.handleView}
            service={service}
            collapsed={this.state.collapse}
          />

          {this.state.collapse ? null : (
            <Fragment>
              {this.state.view === 'form' ? (
                <Fragment>
                  <ServiceForm appId={appId} formData={service} onClose={this.toggleCollapse} />
                  <MenuActionsMobile>
                    <Link onClick={() => this.handleView('status')}>
                      <Eye size="16" /> {'Estado de la solicitud'}
                    </Link>
                  </MenuActionsMobile>
                </Fragment>
              ) : (
                <Fragment>
                  <ServiceDetail>
                    <ServiceDetailItem />
                    <AdvisersLeadsDetail service={service} handleTransaction={this.handleTransaction} />
                  </ServiceDetail>

                  <MenuActionsMobile>
                    <Link onClick={() => this.handleView('form')}>
                      <FileText size="16" /> {'Datos proporcionados'}
                    </Link>
                  </MenuActionsMobile>
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      </ServiceInner>
    );
  }
}
